import React from "react"

const MouseIcon = ({ fill }) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_464_498)">
			<path
				d="M20 8.99995C19.96 4.60995 16.4 1.06995 12 1.06995C7.6 1.06995 4.04 4.60995 4 8.99995V14.9999C4 19.4199 7.58 22.9999 12 22.9999C16.42 22.9999 20 19.4199 20 14.9999V8.99995ZM18 8.99995H13V3.15995C15.81 3.62995 17.96 6.05995 18 8.99995ZM11 3.15995V8.99995H6C6.04 6.05995 8.19 3.62995 11 3.15995ZM18 14.9999C18 18.3099 15.31 20.9999 12 20.9999C8.69 20.9999 6 18.3099 6 14.9999V10.9999H18V14.9999Z"
				fill={fill || '#11364E'}/>
		</g>
		<defs>
			<clipPath id="clip0_464_498">
				<rect width="24" height="24" fill="white"/>
			</clipPath>
		</defs>
	</svg>
)

export default MouseIcon